import React from "react";

interface SelectOptionProps extends React.InputHTMLAttributes<HTMLInputElement> {
  children: React.ReactNode;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function SelectOption({
  children,
  type = "checkbox",
  className,
  ...rest
}: SelectOptionProps) {
  return (
    <label className="flex justify-start cursor-pointer">
      <input type={type} {...rest} className="peer sr-only" />
      <div
        className={`flex items-center gap-1 px-4 py-2.5 rounded-full
         

        transition-all duration-200 
        border border-border-token-brand-subtle 
        text-fg-brand-subtle 
        label-s-semibold 
        bg-bg-brand-tertiary-default

        hover:bg-bg-brand-tertiary-hover 
        peer-checked:bg-bg-brand-tertiary-active 
        peer-checked:border-border-token-brand-subtle
        peer-checked:hover:bg-bg-brand-tertiary-hover
        peer-checked:hover:border-border-token-brand-subtle
        peer-checked:active:bg-bg-brand-tertiary-active
        peer-checked:active:border-border-token-brand-subtle
        `}
      >
        <p className="text-fg-neutral-strong label-s-medium">{children}</p>
      </div>
    </label>
  );
}

export default SelectOption;
